export const ERRORS_FOR_SHOW_ANALYSE_MODAL = [
  'CapacityMustBeGreaterToAccomodateAllMemberships',
  'MemberAgeIsOutOfRange',
];
